import { useRef } from 'react';

type ThrottleFunction = (func: () => void, delay?: number) => void;

const useThrottle = () => {
  const throttleSeed = useRef<null | ReturnType<typeof setTimeout>>(null);

  const throttleFunction = useRef<ThrottleFunction>((func, delay = 300) => {
    if (!throttleSeed.current) {
      func();
      throttleSeed.current = setTimeout(() => {
        throttleSeed.current = null;
      }, delay);
    }
  });

  return throttleFunction.current;
};

export default useThrottle;
